import type { RcmPayorOption } from '@ehr/shared';

/**
 * ehr#176 (Chase 10-12): RCM keeps one payor per plan state (Aetna CA, Aetna TX, …), so the
 * Insurance / Payor dropdown listed "Aetna" five times and saved whichever came first. Each
 * option is now that payor's own id; a name RCM has more than once shows its state.
 */
export function payorOptions(
  known: RcmPayorOption[],
): { value: string; label: string; search: string }[] {
  const seen = new Map<string, number>();
  for (const p of known) seen.set(p.name.toLowerCase(), (seen.get(p.name.toLowerCase()) ?? 0) + 1);
  return known.map((p) => {
    const repeated = (seen.get(p.name.toLowerCase()) ?? 0) > 1;
    const name = repeated && p.state ? `${p.name} (${p.state})` : p.name;
    return {
      value: p.id,
      label: p.class ? `${name} · ${p.class}` : name,
      search: [p.payerId, p.state].filter(Boolean).join(' '),
    };
  });
}

/**
 * Which option a saved insurance entry shows: its RCM payor id when RCM still has it; else the
 * one payor with that name; '' when the name is ambiguous (several states) or not in RCM.
 */
export function payorValue(known: RcmPayorOption[], name: string, rcmId: string): string {
  if (rcmId && known.some((p) => p.id === rcmId)) return rcmId;
  const byName = known.filter((p) => p.name === name);
  return byName.length === 1 ? byName[0]!.id : '';
}
